/** @module csi/widget/SelectMenuTextPrefixRemovable */
define([
	"dojo/_base/declare",
	"dijit/_WidgetsInTemplateMixin",
	"./SelectMenuRemovable",
	"dojo/text!./SelectMenuTextPrefixRemovable.html"
], function(declare, _WidgetsInTemplateMixin, SelectMenuRemovable, template) {
	return declare([SelectMenuRemovable, _WidgetsInTemplateMixin], {
		templateString: template,
		textSuffix: "",
		textValue: "",
		prefixTextNode: null,
		textSuffixNode: null,
		focusDefault: true,
		
		/**
		 * Adds text suffix to the widget
		 */
		buildRendering: function() {
			this.inherited(arguments);
			this.prefixTextNode.onChange = this.onChangeText;
		},
		
		/**
		 * focus on select Node
		 */
		focus: function() {
			if(this.focusDefault && !this.prefixTextNode.focused){
				this._selectNode.focus();
			} else {
				this.prefixTextNode.focus();
				this.focusDefault = true;
			}
		},
		/**
		 * Extension point for on change text value
		 */
		onChangeText: function(val) {},
		
		/**
		 * validate both textbox and select dropdown
		 */
		validate: function() {
			var textValidate = this.prefixTextNode.validate();
			if(!textValidate) {
				this.focusDefault = false;
			}
			
			return this.inherited(arguments) && textValidate;
		},
		/**
		 * sets the suffix content
		 */
		_setTextSuffixAttr: {node: "textSuffixNode", type: "innerText"},
		
		/**
		 * As the widget is having multiple values handle in such a way that it can accept values for both select and text widgets
		 * @param {value} Object or String
		 */
		_setValueAttr: function(value) {
			if(value && typeof value === "object") {
				this.textValue = value.textValue || "";
				this.inherited(arguments, [value.value]);
			} else {
				this.inherited(arguments);
			}
			
			this.prefixTextNode.set('value',this.textValue);
		},
		
		/**
		 * Returns formated values from both widgets
		 */
		_getValueAttr: function() {
			var prefixValue = this.prefixTextNode.get('value');
			this.textValue = isNaN(prefixValue) ? "" : prefixValue;
			var value = this.inherited(arguments)
			if(!this.textValue && !value) {
				return null;
			} else {
				return {
					value: value,
					textValue: this.textValue > 100 ? null : this.textValue
				};
			}
		}
	});
});